export function combinedTax(salesTax: number | null, shippingTax: number | null): number | null {
  if (salesTax === null && shippingTax === null) return null;
  return (salesTax ?? 0) + (shippingTax ?? 0);
}
